/* eslint-disable no-unused-vars */
import React from "react";
import { useDispatch } from "react-redux";
import {isIconButnActive}  from "../Services/Redux/Reducers/commonSlice";
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

function FaqBeta() {
    const dispatch = useDispatch();
    const { t } = useLanguage();

    return (
        <div id="faqCanvas" className="usersection_faqbeta px-4 mx-1 py-2">
            <div className="faq-beta">
                <div className="faq-header">{t("Ask Ralph FAQs")}</div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("What is Ask Ralph?")}</div>
                <div className="faq-content">
                {t("Developed by Ralph Lauren, Ask Ralph is an AI-powered styling assistant that offers personalized fashion guidance and a streamlined shopping experience. It is our latest innovation in conversational commerce, using machine learning and natural language processing to understand and assist you with your style choices.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Who is this available to?")}</div>
                <div className="faq-content">
                {t("Currently, the Ask Ralph tool is available exclusively to Ralph Lauren App account holders in the United States. Be sure to share any feedback you may have with us, as it will be incorporated into future Ask Ralph enhancements.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Are all products available within the Ask Ralph Styling Assistant?")}</div>
                <div className="faq-content">
                    {t("At this time, Ask Ralph has extensive knowledge across our various brands and will recommend most products, with some exceptions.")}
                    {/* At this time, Ask Ralph will recommend products across Purple Label, Collection, RRL, Men’s and Women’s Polo Ralph Lauren, and Kids brands. The tool currently does not support requests regarding Vintage, Create Your Own, furniture, rugs, lighting, pet apparel, or gift cards. */}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("What can the Ask Ralph Stylist do?")}</div>
                <div className="faq-content">
                {t("Ask Ralph is your personal AI stylist, made to assist you in your shopping journey. Whether you're looking for outfit inspiration for a glamorous party or searching for the perfect gift, Ask Ralph is here to help. Whether asking, \"What should I wear for a wedding reception in the Hamptons next March?\" or \"Show me different tops featuring the Polo Bear\" or \"What gift ideas do you have for a friend?\", Ask Ralph is designed to answer all of these questions and more, making your shopping experience seamless and enjoyable.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How Does Ask Ralph Work And Come Up With Its Answers?")}</div>
                <div className="faq-content">
                {t("Ask Ralph works by using artificial intelligence to interact with you in a conversational manner. When you ask a question or make a request, the AI analyzes your input and draws from its extensive knowledge of Ralph Lauren’s products, brand knowledge, style guidelines, and information across the web to offer recommendations. You can refine your requests by providing more details and Ask Ralph will adapt its suggestions accordingly. Please note that Ask Ralph is designed to act solely as a styling assistant, so please refrain from asking financial, medical, legal, or any other derogatory or inappropriate information. Please avoid disclosing any personal or sensitive information, too.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How accurate are the AI stylist's suggestions?")}</div>
                <div className="faq-content">
                {t("As we continue to evolve Ask Ralph, there will be instances where the responses are not 100 percent accurate or aligned with our RalphLauren.com or in-store experiences. If this is the case, please report these instances using the thumbs up/thumbs down feedback mechanisms, located directly in the chat.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How do I find the right outfit for a specific occasion?")} <span style={{ textTransform: 'lowercase' }}>({t("e.g., wedding, job interview")})</span></div>
                <div className="faq-content">
                {t("To find the right outfit for a specific occasion, you can simply tell Ask Ralph about the event you are attending, your style preferences, sizes, and any other requirements. Ask Ralph will present you with a curated selection of Ralph Lauren attire that fits your needs, offering options for different looks and suggesting complete outfits to ensure you are dressed for the occasion.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("What should I do if the virtual stylist does not understand my requests?")}</div>
                <div className="faq-content">
                {t("If Ask Ralph does not understand your requests, try to provide more specific information, or use simpler, clearer language. Ensure that you are being direct with your questions or requests. The more detailed your question the better the response will be.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Is there a limit to how many times I can use the Ask Ralph stylist?")}</div>
                <div className="faq-content">
                {t("There is no limit to how many times you can use the stylist. There is a timeout period in which due to inactivity your chat conversation will be saved and stored in chat history.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How can I access and clear my chat history?")}</div>
                <div className="faq-content">
                {t("Chat history will be stored and accessible through the main home page of Ask Ralph. Upon clicking on one of the chats, you will be able to review or delete previous chat history. Currently there is no ability to re-engage with a chat and input new questions or responses. Clearing chat history removes questions and responses from that specific chat.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Can I save my favorite outfits or recommendations?")}</div>
                <div className="faq-content">
                {t("There is no direct feature to save outfits and store them. However, all conversations will be stored in your chat history for you to reference previous outfit and product recommendations.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Can the AI stylist consider my existing wardrobe?")}</div>
                <div className="faq-content">
                    {t("Currently the beta version of Ask Ralph does not take into consideration your personal wardrobe or any past Ralph Lauren purchases you have made.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Is the virtual stylist available in multiple languages?")}</div>
                <div className="faq-content">
                    {t("Currently, Ask Ralph is only available within the Ralph Lauren App in the United States. Multi-language support may be considered in future expansions.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("Why did I get a response that did not directly answer my question?")}</div>
                <div className="faq-content">
                    {t("There are multiple reasons why Ask Ralph may not answer a question. Ask Ralph is mainly a styling and brand knowledge tool. Certain responses may not be available right now, but we are actively working to expand and answer more questions. Ask Ralph may choose not to respond to certain questions due to the inappropriate nature of them or if it is outside our brand guidelines.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("What should I do if I'm not satisfied with the recommendations?")}</div>
                <div className="faq-content">
                    {t("If not satisfied with a recommendation, please provide feedback through the thumbs up / thumbs down mechanisms located directly in the chat. Then, treat this experience as a conversation and provide more context, reword the question, or ask follow-up questions.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How can I provide feedback on the AI stylist's recommendations?")}</div>
                <div className="faq-content">
                    {t("To provide feedback on your recommendation, use the thumbs up/thumbs down mechanisms located directly in the chat to determine the recommendation's quality as it relates to your input. This will allow us to continue to improve our tool over time and enhance your experience with Ask Ralph.")}
                </div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">{t("Privacy and Security")}</div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">{t("What personal information does the virtual stylist collect?")}</div>
                <div className="faq-content">
                    {t("Ask Ralph will store information related to the chat history of the conversation, as well as any feedback you provide through the use of the assistant. Your email address is also stored for authentication purposes. The feedback provided, regarding recommendations and the Ask Ralph tool, will be collected and analyzed to improve the quality of the assistant. At present, the tool does not collect information related to your customer profile with us and only relies on chat conversation to provide recommendations.")}
                </div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">{t("Is my personal information secure when using the tool?")}</div>
                <div className="faq-content">
                    {t("Yes, personal information remains in the Ralph Lauren cloud landscape, where it is encrypted and stored. Your personal information is not shared with third parties as a result of using the tool. Your personal information is not transferred outside of North America as part of the tool’s use.")}
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">{t("How can I learn more about how my personal data is used and processed?")}</div>
                <div className="faq-content">
                    {t("If you want to learn more about how your personal data can be used by Ralph Lauren, please read our privacy policy")} <a href="https://www.ralphlauren.com/customerservice?cid=cs-privacy-notice" target="_blank" rel="noopener noreferrer"> {t("here")}</a>{t(", or contact us at")}
                    <a href="mailto:privacy@ralphlauren.com" target="_blank" rel="noopener noreferrer"> {t("privacy@ralphlauren.com.")}</a>
                </div>
            </div>
            <div className="faq-gradient"></div>
            <div className="offcanvas-header d-flex justify-content-end"
                style={{  position: "fixed", bottom: "40px", left: "50%",transform: "translateX(-50%)", zIndex: "1000" }}>                                           
                <button
                    name="closeButton"
                    type="button"
                    className=""
                    onClick={()=>{dispatch(isIconButnActive(false))}}
                    data-bs-dismiss="offcanvas"
                    style={{
                        backgroundColor: "#e1e1dc",
                        borderRadius: "50%",
                        padding: "0",
                        width: "40px",
                        height: "40px",
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <img src="/static/assets/close.svg" alt="close" height="16px" width="16px" />
                </button>
            </div>
        </div>
    );
}

export default FaqBeta;